"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RequiredIndicatorDiv = _styledComponents["default"].span.attrs(function () {
  return {
    id: "required-indicator"
  };
}).withConfig({
  displayName: "RequiredIndicator__RequiredIndicatorDiv",
  componentId: "k0xaf8-0"
})(["&&&{color:", ";}"], function (props) {
  return props.theme["mlb-red"];
});

var RequiredIndicator = function RequiredIndicator(props) {
  return _react["default"].createElement(RequiredIndicatorDiv, props, "*");
};

var _default = RequiredIndicator;
exports["default"] = _default;